import { Component, OnInit,Input } from '@angular/core';
import { TimeFrame } from '../../../classes';
import { DataIoService } from '../../../services/data-io.service';
import { TranslationService } from '../../../services/translation.service';
@Component({
  selector: 'app-day-overview',
  templateUrl: './day-overview.component.html',
  styleUrls: ['./day-overview.component.scss']
})
export class DayOverviewComponent implements OnInit {
	@Input('day') day : number;
	@Input('zone') zone : number;
  @Input('selected') selected : boolean = false;
  @Input('table') table : string;
  days = [ 
    'DELIGHT_WEEKLY_PLANNER_MONDAY',
    'DELIGHT_WEEKLY_PLANNER_TUESDAY',
    'DELIGHT_WEEKLY_PLANNER_WEDNESDAY',
    'DELIGHT_WEEKLY_PLANNER_THURSDAY',
    'DELIGHT_WEEKLY_PLANNER_FRIDAY',
    'DELIGHT_WEEKLY_PLANNER_SATURDAY',
    'DELIGHT_WEEKLY_PLANNER_SUNDAY'
  ];
  timeslots:Array<TimeFrame>
  private _debug : boolean=false;
  debug(msg:string){
    if(this._debug){
      console.log("DayOverviewComponent: "+msg);
    }
  }

  constructor(private ioService: DataIoService, private translator: TranslationService) { }
  

  getDay(){
  	if(this.day != null){
      return this.translator.tr(this.days[this.day]);
  	}
  	return 'unbekannt';
  }
  ngOnInit() {
    this.debug("Init day "+this.day);
    this.debug("Init zone "+this.zone);
    this.debug("Init selected "+this.selected);
    this.debug("Table selected: "+this.table);

    let timeframeManager=this.ioService.deviceInfo().getZoneById(this.zone).getTimeFrameManager(this.table);
    if(timeframeManager != null){
      this.debug("Got timeframemanager for zone "+this.zone);
      this.timeslots = timeframeManager.forDay(this.day);
    }else{
      this.debug("No timeframemanager for zone "+this.zone);
    }
  }

}
